import { render, staticRenderFns } from "./NavbarToggleButton.vue?vue&type=template&id=5c0745d5&"
import script from "./NavbarToggleButton.vue?vue&type=script&lang=js&"
export * from "./NavbarToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0745d5')) {
      api.createRecord('5c0745d5', component.options)
    } else {
      api.reload('5c0745d5', component.options)
    }
    module.hot.accept("./NavbarToggleButton.vue?vue&type=template&id=5c0745d5&", function () {
      api.rerender('5c0745d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navbar/NavbarToggleButton.vue"
export default component.exports